import { LOCAL_STORAGE_REDIRECT_PATH_KEY } from '@dtx-company/true-common/src/constants/auth'
import { Routes } from '@dtx-company/true-common/src/constants/routes'
import { useEffect } from 'react'
import { useRouter } from 'next/router'
import useLocalStorageState from 'use-local-storage-state'

export function useCleanupLocalStorageOnPageLoad(): void {
  const { pathname } = useRouter()

  const [value, __, { removeItem }] = useLocalStorageState<string | undefined>(
    LOCAL_STORAGE_REDIRECT_PATH_KEY
  )

  useEffect(() => {
    if (value && pathname !== Routes.FRONTEGG_SSO_REDIRECT) {
      removeItem()
    }
  }, [pathname, removeItem, value])
}
